<h2>Visualisation</h2>
<iframe [src]="data.pdfLink | safeUrl" width="100%" height="100%"></iframe>
